module.exports = __webpack_public_path__ + "img/banner2.8796a921.jpg";